import { Stack, Button, Typography } from '@mui/material';
import { BlankSheetsIcon } from '../../icons/BlankSheetsIcon.tsx';
import { Link } from 'react-router-dom';
import { PlusSmall } from '../../icons/PlusSmall.tsx';

export const PlansEmptyState = () => {
  return (
    <Stack
      sx={{
        width: "100%",
        alignItems: "center",
        justifyContent: "center",
        height: "100%"
      }}>
      <BlankSheetsIcon />
      <Typography
        variant="body2"
        sx={{
          fontWeight: 600,
          marginBottom: 0.5
        }}>
        No plan templates yet
      </Typography>
      <Typography
        variant="body2"
        sx={{
          textAlign: "center",
          maxWidth: "323px",
          marginBottom: 2,
          color: "#7E8796"
        }}>
        You’ll be able to view and manage them here once you’ve created some.
      </Typography>
      <Link to="/plans/create">
        <Button
          variant="contained"
          startIcon={<PlusSmall />}
          sx={(theme) => ({
            background: '#E8EBF2',
            color: theme.palette.text.primary,
            '&:hover': {
              background: 'rgb(232,235,242, 0.4)',
            },
          })}
        >
          Create plan template
        </Button>
      </Link>
    </Stack>
  );
};
